import { createFileRoute } from '@tanstack/react-router';
import { SeoPositionsPage } from '@/pages/SeoPositionsPage';

export const Route = createFileRoute('/_authed/seo/positions')({
  component: SeoPositionsPage,
});
